<template>
  <div class="room-types-tab shared-index">
    <el-row class="table-title" type="flex" align="center">
      <div class="table-title__left">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleChangeTab">
          <el-tab-pane name="room_types">
            <div slot="label">
              Hạng phòng
              <span>({{ total }})</span>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div style="display: flex; align-items: center;">
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            size="small"
            class="mr-2"
            @click="createTag"
          >Thêm</el-button>
          <import-excel-button
            class="mr-2"
            size="small"
            :disabled="loading"
            :total="total"
            :columns="excelColumns"
            :type="'room_type'"
            :titles="importExportTitles"
            :active-tab="'room_type'"
            @reload="handleChangeTab"
          />
          <export-excel-button
            class="mr-2"
            size="small"
            :disabled="loading"
            :total="total"
            :columns="excelColumns"
            :type="'room_type'"
            :titles="importExportTitles"
            :active-tab="'room_type'"
          />
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            size="small"
            @click="handleChangeTab"
          >Làm mới</el-button>
        </div>
      </div>
    </el-row>
    <list-room-types
      :loading="loading"
      :data="allRoomTypes"
      @reload="handleReloadAfterDelete"
      @update="updateRoomType"
    ></list-room-types>
    <el-row type="flex" justify="end" class="my-4">
      <el-pagination
        :current-page="page"
        :page-size="limit"
        :total="total"
        background
        layout="total, prev, pager, next"
        @current-change="handleChangePage"
      ></el-pagination>
    </el-row>
    <room-type-popup
      v-if="formVisible"
      :visible="formVisible"
      :room-type="selectedRoomType"
      @close="formVisible = false"
      @reload="loadData"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ListRoomTypes from './components/List.vue'
import RoomTypePopup from '../../components/popups/RoomType.vue'
import { getRoomTypes } from '@/services/room-type'
import TYPE from '@/data/type'

import ImportExcelButton from '../../components/buttons/ImportExcel.vue'
import ExportExcelButton from '../../components/buttons/ExportExcel.vue'

export default {
  name: 'RoomTypes',
  components: {
    ListRoomTypes,
    RoomTypePopup,
    ImportExcelButton,
    ExportExcelButton
  },
  data() {
    return {
      loading: false,
      allRoomTypes: [],
      selectedRoomType: null,
      activeTab: 'room_types',
      total: 0,
      limit: 10,
      page: 1,
      searchText: '',
      formVisible: false
    }
  },
  computed: {
    ...mapGetters(['language']),
    params() {
      return {
        page: this.page,
        per_page: this.limit,
        locale: this.language
      }
    },
    excelColumns() {
      const eColumns = this.$route.meta.data.index.excelColumns
      return (eColumns || []).map((c) =>
        TYPE.EXCEL_COLUMNS.find((column) => c === column.key)
      )
    },
    importExportTitles() {
      return [{ name: 'Hạng phòng', value: 'room_type' }]
    }
  },
  watch: {
    language: 'loadData'
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.formVisible = false
      getRoomTypes(this.params).then((response) => {
        this.allRoomTypes = response.result
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleChangePage(page) {
      this.page = page
      this.loadData()
    },
    createTag() {
      this.selectedRoomType = null
      this.formVisible = true
    },
    updateRoomType(data) {
      this.selectedRoomType = data
      this.formVisible = true
    },
    handleChangeTab() {
      this.page = 1
      this.loadData()
    },
    handleReloadAfterDelete() {
      if (this.allRoomTypes.length === 1 && this.page > 1) {
        this.page = this.page - 1
      }
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.room-types-tab {
  .table-title {
    &__left {
      max-width: calc(100% - 200px);
      .el-tabs {
        max-width: 100%;
      }
    }
  }
}
</style>
